import Divider from './components/Divider.component';
import PropTypes from 'prop-types';
import Section from './components/Section.component';
import Text from './components/Text.component';
import _ from 'lodash';
import { Stack } from '@mui/material';
import DownlaodComponent from './components/Download.component';
import Link from './components/Link.component';
import RectangleChip from '../common/RectangleChip.component';

export const DynamicControl = ({ type, label, value, ...props }) => {
  switch (type) {
    case 'divider': {
      return <Divider label={label} />;
    }
    case 'section': {
      return <Section label={label} {...props} />;
    }
    case 'text': {
      return <Text label={label} value={value} {...props} />;
    }
    case 'boolean':
      return <Text label={label} value={value ? 'true' : 'false'} />;

    case 'download':
      return <DownlaodComponent label={label} value={value} {...props} />;

    case 'link':
      return <Link label={label} value={value} />;

    case 'rectangle_chip':
      const colorChip =
        props?.options &&
        _.find(
          props?.options,
          (item) => item?.label.toUpperCase() === value.toUpperCase()
        );

      return (
        <Stack direction={'row'}>
          <Text label={label} />
          <RectangleChip
            width='auto'
            value={value}
            color={colorChip?.textHex || props?.color || '#fff'}
            backgroundColor={colorChip?.hex || props?.backgroundColor || 'grey'}
            size={props?.size || 'small'}
          />
        </Stack>
      );

    default:
      return null;
  }
};

DynamicControl.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  sx: PropTypes.object,
};
